/**
 * The grid class for a row of key-figure tiles. A known count gets columns
 * that divide it (2, 3, 4, 6, 7), so no row ends in an orphan slot; any
 * other count flows and the last row's tiles grow to close the gap.
 */
export function usageKpiGridClass(count: number) {
  switch (count) {
    case 2:
      return "usage-report-kpis usage-report-kpis--two"
    case 3:
      return "usage-report-kpis usage-report-kpis--three"
    case 4:
      return "usage-report-kpis usage-report-kpis--four"
    case 6:
      return "usage-report-kpis usage-report-kpis--six"
    case 7:
      return "usage-report-kpis usage-report-kpis--seven"
    default:
      return count <= 1 ? "usage-report-kpis" : "usage-report-kpis--flow"
  }
}
